import { render } from "./PlantInformationHeader.vue?vue&type=template&id=3f9e5f20&scoped=true&ts=true"
import script from "./PlantInformationHeader.vue?vue&type=script&lang=ts"
export * from "./PlantInformationHeader.vue?vue&type=script&lang=ts"

import "./PlantInformationHeader.vue?vue&type=style&index=0&id=3f9e5f20&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3546012314/src/biomass-frontend-poc/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f9e5f20"]])

export default __exports__